import { useMemo } from "react"
import { waitFor } from "xstate"
import { useSelector } from "@xstate/react"
import { useSearchParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHome, faSignIn } from "@fortawesome/free-solid-svg-icons"

import { authMachine } from "../machines/AuthMachine"
import { getAuthErrorMessage, getAuthStateMessage } from "@recordsure/unity-auth-machine"

async function loader() {
  await waitFor(authMachine, (state) => state.hasTag("Settled"))
  return null
}

export default function Route() {
  const [searchParams] = useSearchParams()

  const code = useSelector(authMachine, (state) => state.context.error)
  const isTokenRevoked = useSelector(authMachine, (state) => state.context.tokenRevoked)
  const isAuthenticated = useSelector(authMachine, (snapshot) => snapshot.matches("authenticated"))

  const message = useMemo(() => {
    if (code == null) return getAuthStateMessage(isAuthenticated)
    return getAuthErrorMessage(code)
  }, [code, isAuthenticated])

  return (
    <div className="w-screen h-screen grid place-items-center">
      <div className="max-w-sm flex-col items-center flex gap-2">
        {isTokenRevoked === false && (
          <div className="flex items-center gap-2 rounded-md border border-warning bg-warning/20 p-4 shadow">
            <h5 className="text-sm font-semibold tracking-wide dark:text-base-content text-warning-content">
              Authentication Error:
            </h5>
            <p className="text-xs">Error revoking auth tokens.</p>
          </div>
        )}
        <a href="/" className="block">
          <img src="/logo.png" alt="Recordsure Logo" className="w-full max-w-[10rem]" />
        </a>
        <h4 className="text-3xl font-bold text-center">{message.main}</h4>
        <p className="text-lg text-balance text-center">{message.content}</p>
        {message.subtitle && <p className="text-balance text-center">{message.subtitle}</p>}
        {isAuthenticated ? (
          <a href="/" className="btn normal-case btn-neutral">
            <FontAwesomeIcon icon={faHome} />
            Home
          </a>
        ) : (
          <button
            type="button"
            aria-label="Log In"
            className="btn normal-case btn-neutral"
            onClick={() => authMachine.send({ type: "LOGIN", path: searchParams.get("from") })}
          >
            <FontAwesomeIcon icon={faSignIn} />
            Log In
          </button>
        )}
      </div>
    </div>
  )
}

Route.loader = loader
